import { defineComponent as _defineComponent } from 'vue'
import type { FeatureCollection } from '@turf/helpers';
import axios from 'axios';
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';

import GeoJsonMap from '@/digital-contracting/managed-contracts/components/GeoJsonMap.vue';
import ThePageSkeleton from '@/layout/components/ThePageSkeleton.vue';
import IconTextLogoOriginal from '@/layout/svg/IconTextLogoOriginal.vue';
import ErrorUserMessage from '@/shared/components/ErrorUserMessage.vue';
import LoadingGlobal from '@/shared/components/LoadingGlobal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageViewer',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const geoJson = ref<FeatureCollection>();
const downloadLink = ref<HTMLLinkElement>();

const baseUrl = origin;
onMounted(() => {
  if (!route.params.fileId) {
    router.replace({ name: '404' });
    return;
  }

  axios
    .get<FeatureCollection>(`/file/${route.params.fileId}`)
    .then(({ data }) => {
      geoJson.value = data;
    })
    .catch((err) => {
      if (err.message.includes('404')) {
        router.replace({ name: '404' });
      } else {
        errorMessage.value = err.message;
      }
    });
});
const errorMessage = ref('');

function downloadFile() {
  downloadLink.value?.click();
}

return { __sfc: true,route, router, geoJson, downloadLink, baseUrl, errorMessage, downloadFile, GeoJsonMap, ThePageSkeleton, IconTextLogoOriginal, ErrorUserMessage, LoadingGlobal }
}

})